import styled from 'styled-components';

export default styled.div`
  padding: 1rem 0 1rem 1rem;
  display: grid;
  grid-template-columns: 100%;
  align-content: center;
`;
